import styled from "styled-components";

export const StyledDocumentLink = styled.a`
    height: 85px;
    width: 145px;
    cursor: pointer;
    padding: 2px;
    border-radius: 15px;
    overflow: hidden;
    transition: .3s;

    &:hover {
        transform: scale(1.05);
    }
`;

export const StyledDocumentImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;